import React from 'react'
import { TextField } from '@mui/material'
import { Controller } from 'react-hook-form'

/**
 * A react-hook-form-bound text field. `helper` shows only while there is no validation error, and
 * anything in `props` lands after the binding — so a caller can supply its own onChange, or pass
 * `select` with MenuItem children.
 */
const Field = ({ control, name, helper, children, ...props }) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState: { error } }) => (
      <TextField
        {...field}
        variant='outlined'
        fullWidth
        error={!!error}
        helperText={error?.message || helper}
        {...props}
      >
        {children}
      </TextField>
    )}
  />
)

export default Field
